import { isOfType } from "../../../../utils";

export interface IDiscreteCategoricalValue {
  type: "discrete_categorical";
  probabilities: Partial<Record<string, number>>;
}

export interface INominalCategoricalValue {
  type: "nominal_categorical";
  category: string;
}

export type ICategoricalValue =
  IDiscreteCategoricalValue | INominalCategoricalValue;

// define typeguards
const isDiscrete = isOfType<IDiscreteCategoricalValue>("discrete_categorical");
export const isNominalCategorical = isOfType<INominalCategoricalValue>(
  "nominal_categorical",
);

export const categoricalValueToString = (
  categoricalValue: ICategoricalValue,
): string => {
  if (isDiscrete(categoricalValue)) {
    return Object.keys(categoricalValue.probabilities)
      .map((key) => {
        return `${key}: ${categoricalValue.probabilities[key]}`;
      })
      .join(", ");
  }
  if (isNominalCategorical(categoricalValue)) {
    return `${categoricalValue.category}`;
  }
  return "";
};
